import { Show } from 'solid-js';
import { disclaimers } from '~/data/config';
import './FormConsent.css';

interface ConsentProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  /** Если true — подсветить и показать сообщение, что галочка обязательна */
  error?: boolean;
}

export function FormConsent(props: ConsentProps) {
  return (
    <div class="form-consent-wrap">
      <label
        class="form-consent"
        classList={{ 'form-consent--error': props.error }}
      >
        <input
          type="checkbox"
          class="form-consent__input"
          checked={props.checked}
          onChange={(e) => props.onChange(e.currentTarget.checked)}
          required
          aria-required="true"
          aria-invalid={props.error || undefined}
        />
        <span class="form-consent__box" aria-hidden="true">
          <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 8 7 12 13 4" />
          </svg>
        </span>
        <span class="form-consent__text">
          Я даю{' '}
          <a href="/personal-data-consent" target="_blank" rel="noopener noreferrer">
            согласие на обработку персональных данных
          </a>{' '}
          и принимаю{' '}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Политику обработки персональных данных
          </a>
          .
        </span>
      </label>
      <Show when={props.error}>
        <p class="form-consent__error" role="alert" aria-live="polite">
          ⚠ Поставьте галочку — без согласия на обработку персональных данных
          я&nbsp;не&nbsp;смогу принять заявку.
        </p>
      </Show>
    </div>
  );
}

export function FormSubmitDisclaimer() {
  return <p class="form-disclaimer">{disclaimers.formSubmit}</p>;
}
